export default "__VITE_ASSET__Bw0T2$ad__"